module.exports = __webpack_public_path__ + "static/media/wuxuanyi.77a9fc8a.png";